import Navigation from '../../components/utils/Navigation';
import NoDataAvailable from '../../components/utils/NoDataAvailable.vue';
import CustomerDialog from '../../components/dialogs/ticketing/CustomerDialog.vue';
import { populateUsefulMaps } from '../../utils/entityMethods/ticket.js';
import { formatMoney } from '../../utils/entityMethods/customer.js';

function emptyClient() {
    return {
        id: null,
        company_name: "",
        vat_number: "",
        address: "",
        city: "",
        postal_code: "",
        country: "IT",
        province: "",
        pec_email: "",
        sdi_code: "",
        hourly_rate: null,
        note: "",
        is_active: true,
        groups: []
    };
}

export default {
    name: "Customers",
    components: { Navigation, NoDataAvailable, CustomerDialog },
    data() {
        return {
            clients: null,
            search: "",
            editing: null
        };
    },
    computed: {
        filteredClients() {
            if (!this.clients) return [];
            const q = (this.search || "").trim().toLowerCase();
            if (!q) return this.clients;
            return this.clients.filter(c =>
                (c.company_name || "").toLowerCase().includes(q) ||
                (c.vat_number || "").toLowerCase().includes(q)
            );
        }
    },
    async mounted() {
        await this.populateUsefulMaps();

        if (!this.$root.checkAuth()) return;
        this.$session.setRoomPC(null);
        if (this.$root.socket) this.$root.socket("SETPC", null);

        // Eventi pilotati dal CustomerDialog
        this.$root.$on("refreshCustomers", async _ => {
            this.$root.customerMap = undefined;
            await this.populateUsefulMaps();
            this.loadClients();
        });

        await this.loadClients();
    },
    beforeDestroy() {
        this.$root.$off("refreshCustomers", this.loadClients);
    },
    methods: {
        formatMoney,
        populateUsefulMaps,
        async loadClients() {
            const res = await this.$api.getCustomers();
            if (res == null) {
                this.clients = [];
                return;
            }
            this.clients = Array.isArray(res) ? res : (res.customers || res.clients || res.data || []);
        },

        async deleteClient(client) {
            const dialogId = Math.floor(100000 + Math.random() * 900000).toString();
            const self = this;
            this.$root.$on(dialogId, async ok => {
                if (ok) {
                    const result = await self.$api.deleteCustomer(client.id, client.company_name);
                    if (result) await self.loadClients();
                }
                self.$root.$off(dialogId);
            });
            this.$root.openYesNoDialog(
                dialogId,
                this.$t("Delete customer"),
                this.$t("deleteConfirmation", { 0: client.company_name })
            );
        }
    }
};
